import { GridFilterModel, GridLogicOperator } from "@mui/x-data-grid-pro";

export const initialFilterModel: GridFilterModel = {
  items: [],
  logicOperator: GridLogicOperator.Or, // Default value
  quickFilterValues: [],
  quickFilterLogicOperator: GridLogicOperator.And, // Default value
};

export const isThereAnyIncompleteFilter = (filterModel: GridFilterModel): boolean => {
  return filterModel.items.some((filter) => !filter?.value);
};
